import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlBundle } from '../../../models/urlBundle';
import { UrlProviderService } from '../../../services/url.provider';

@Component({
  selector: 'eid-unsupported-country-satrix-mobile',
  templateUrl: './unsupported-country-satrix.mobile.component.html',
  styleUrls: ['./unsupported-country-satrix.mobile.component.scss']
})
export class UnsupportedCountrySatrixMobileComponent {
  public urlBundle$: Observable<UrlBundle>;

  constructor(private urlProviderService: UrlProviderService) {
    this.urlBundle$ = this.urlProviderService.urlBundle$;
  }
}
